import { styledForMobile } from "@l2r-front/l2r-ui"

export const BottomRightAnchor = styledForMobile("div")(({ theme }) => ({
    alignItems: "flex-end",
    bottom: theme.spacing(12),
    display: "flex",
    flexDirection: "column-reverse",
    gap: theme.spacing(3),
    pointerEvents: "none",
    position: "absolute",
    right: theme.spacing(2),
    zIndex: 3,

    "& > *": {
        pointerEvents: "auto",
    },
}))